import { QueryParams } from '@ml/shared/types/query-params';
import { TaskFilterParams } from '@ml/tasks/types/interfaces';
import { TaskQueryParams } from '@ml/tasks/types/classes/task-query-params.class';

export class TaskFilters {
  employee: number;
  status: string[];

  constructor(taskFilters?: any) {
    Object.assign(this, taskFilters);
  }

  get empty() {
    return !this.employee && !(this.status && this.status.length > 0);
  }

  get queryParams(): TaskQueryParams {
    const params = new TaskQueryParams();
    if (this.status) {
      params.status = this.status ? this.status.join(',') : '';
    }
    if (this.employee) {
      params.employee = this.employee;
    }

    return params;
  }

  static fromParams(params: TaskFilterParams): TaskFilters {
    const taskFilter = new TaskFilters();
    if (params.status) {
      taskFilter.status =
        typeof params.status === 'string' ? [params.status] : params.status;
    }
    if (params.employee) {
      taskFilter.employee = +params.employee;
    }

    return taskFilter;
  }

  get params(): TaskFilterParams {
    const filterParams: TaskFilterParams = {};
    if (this.status) {
      filterParams.status = this.status;
    }
    if (this.employee) {
      filterParams.employee = this.employee;
    }

    return filterParams;
  }
}
